module.exports = __webpack_public_path__ + "static/media/grip-horizontal.b3f18378.svg";